<template>
  <v-row>
    <v-col cols="12">
      <Form
        dispatch="documentStore/update"
        button_title="update"
        button_icon="mdi-pencil"
        :document="document"
        :resource-loading="!document.id"
      ></Form>
    </v-col>
  </v-row>
</template>

<script>
import Form from "./FormDocument";

export default {
  name: "EditDocument",
  components: {
    Form
  },
  computed: {
    document: {
      get() {
        let document = this.$store.getters["documentStore/getItem"];
        document._folder = document._folder || { id: null };
        document._template = document._template || { id: null };
        document._receiver = document._receiver || { id: null };
        document._creditor = document._creditor || { id: null };
        document._sender = document._sender || { id: null };
        document._template._type = document._template._type || { id: null };
        document.status = document.status || { id: null };
        document.isDraft = document.draft !== false;
        return { ...document };
      }
    }
  }
};
</script>

<style scoped></style>
